// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".other-select[data-v-1587d015] {\n  margin-left: 20px;\n  margin-top: 10px;\n}", "",{"version":3,"sources":["/spug/spug_api/repos/119_10566_20260928180206/packages/kankan-laser/src/views/coordinate/index.vue"],"names":[],"mappings":"AACA;EACE,iBAAA;EACA,gBAAA;AAAF","file":"index.vue","sourcesContent":["\n.other-select {\n  margin-left: 20px;\n  margin-top: 10px;\n}\n"]}]);
// Exports
module.exports = exports;
